export default function () {
  return {
    search: "",
    category_type: null,
    category: null,
    license: null,
    prev_license: null,
    min_price: null,
    max_price: null,
    inventory_grouping: {
      available: false,
      value: null,
    },
    listingAction: null,
    entryPoint: null,
    orders_per_page: "10",
    products_per_page: 20,
    items_per_page: 20,
    inventory_page_layout: "col-2",
    items_for_new_product: [],
    show_my_listings: true,
    previously_purchased: false,
    marketplace_view_mode: "grid",
    retailer_weekly_sale_sources: ["Affiliated", "Unaffiliated", "Sale"]
  };
}
